import React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../services/common/className";
import "./threeDotsMenu.scss";
import "../../sass/common.scss";

export interface DropdownMenuItem {
  text?: string | React.ReactNode;
  to?: string;
  icon?: React.ReactNode;
  onClick?: (params?: any | undefined) => void;
  disabled?: boolean;
}

export interface ThreeDotsMenuProps {
  menuItems: DropdownMenuItem[];
  separator?: boolean;
  separatorIndex?: number;
}

const MenuItemWrapper: React.FC<any> = ({ to, disabled, children }) => (
  !disabled && to ? <Link to={to}>{children}</Link> : children
);


const ThreeDotsMenu: React.FC<ThreeDotsMenuProps> = (props) => {

  return (
    <>
      {props.menuItems.map((menuItem, index) => (
        <React.Fragment key={`xgs-three-dots-menu-${menuItem.text}`}>
          <MenuItemWrapper to={menuItem.to} disabled={menuItem.disabled}>
            <div
              className={cn("xgs-three-dots-menu__item")({
                inactive: !menuItem.onClick,
                disabled: menuItem.disabled,
              })}
              title={typeof menuItem.text === "string" ? menuItem.text : ""}
              onClick={() => {
                if (menuItem.onClick && !menuItem.disabled) {
                  menuItem.onClick();
                }
              }}
            >
              <div className="xgs-three-dots-menu__icon">
                {menuItem.icon}
              </div>
            </div>
          </MenuItemWrapper>
          {props.separator && props.separatorIndex === index && <hr style={{ width: "55%", margin: "0 auto" }} />}
        </React.Fragment>
      ))}
    </>
  )
};

export default ThreeDotsMenu;
